import {useSelector} from 'react-redux';

import useCheckFirmware from '../../hooks/fwu/useCheckFirmware';
import {selectIsFwuPage} from '../../state/selectors/global';

const useFwuBackgroundCheck = () => {
    const isFwuPage = useSelector(selectIsFwuPage);

    // do not check if isFwuPage, there is its own synchronous check on the page
    useCheckFirmware({isCheckEnabled: !isFwuPage});
};

export default useFwuBackgroundCheck;
